export default class ForumName {

  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
  }

  public isEqualTo(other: ForumName): boolean {
    return this.value === other?.value;
  }

  public get value(): string {
    return this._value;
  }

  public static get Prototype(): ForumName {
    return new ForumName("");
  }

  public fromJSON(value: string): ForumName {
    return new ForumName(value);
  }
  public toJSON(): string {
    return this.value;
  }
  public clone(): ForumName {
    return new ForumName(this.value);
  }
}
